import React, { Component } from "react";

class SelectorWidgetDesktop extends Component {
  render() {
    let {
      endIcon,
      dottedLineDesktop,
      startIcon,
      renderStoresSelector,
      onStoreSet,
      errorMessage,
      bathroom,
      redbanc,
      dd,
      info,
      milk,
      elevator,
      parking,
      config
    } = this.props;
    return (
      <div className="card card-1 pt-3 pb-3 pl-4">
        <div
          id="left-container"
          className="float-left route-container"
          style={{ height: "100%" }}
        >
          <img
            alt=""
            style={{ position: "absolute", top: "25px", left: "13px" }}
            src={endIcon}
          />
          <img
            alt=""
            style={{ position: "absolute", top: "51px", left: "19px" }}
            src={dottedLineDesktop}
          />
          <img
            alt=""
            style={{ position: "absolute", top: "110px", left: "13px" }}
            src={startIcon}
          />
        </div>
        <div className="card card-1">{renderStoresSelector(true)}</div>
        <div id = "asdqwe" className="card card-1 mt-4">{renderStoresSelector(false)}</div>
        {/* <div className="text-center mt-3">
          <div className="services-title-desktop-display">Servicios</div>
        </div>
        <div className="services-container mt-1">
          <div className={ config.services.filter(f => f === "bathroom")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={bathroom}
              onClick={() => onStoreSet(true, false, "bathroom")}
            />
            <br />
            <span className="desktop-service-name">Baño</span>
          </div>
          <div className={ config.services.filter(f => f === "redbanc")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={redbanc}
              onClick={() => onStoreSet(true, false, "redbanc")}
            />
            <br />
            <span className="desktop-service-name">Cajero</span>
          </div>
          <div className={ config.services.filter(f => f === "dd")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={dd}
              onClick={() => onStoreSet(true, false, "dd")}
            />
            <br />
            <span className="desktop-service-name">Directorio Digital</span>
          </div>
          <div className={ config.services.filter(f => f === "info")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={info}
              onClick={() => onStoreSet(true, false, "info")}
            />
            <br />
            <span className="desktop-service-name">Informaciones</span>
          </div>
        </div>
        <div className="services-container mt-2">
          <div className={ config.services.filter(f => f === "milk")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={milk}
              onClick={() => onStoreSet(true, false, "milk")}
            />
            <br />
            <span className="desktop-service-name">Sala de Lactancia</span>
          </div>
          <div className={ config.services.filter(f => f === "elevator")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={elevator}
              onClick={() => onStoreSet(true, false, "elevator")}
            />
            <br />
            <span className="desktop-service-name">Ascensores</span>
          </div>
          <div className={ config.services.filter(f => f === "parking")[0] ? "d-inline-block" : "d-none" }>
            <img
              alt=""
              className="service-image-desktop"
              src={parking}
              onClick={() => onStoreSet(true, false, "parking")}
            />
            <br />
            <span className="desktop-service-name">Estacionamiento</span>
          </div>
        </div> */}
        {errorMessage && (
          <div className="pl-3 pt-1 error-message">{errorMessage}</div>
        )}
      </div>
    );
  }
}

export default SelectorWidgetDesktop;



// WEBPACK FOOTER //
// ./src/views/start/SelectorWidgetDesktop.js